export default __webpack_public_path__ + "static/media/labyrinthen-floorplan-H1.a8bf8932.jpg";